<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">


              </CCol>
              <CCol col="8" style="text-align: end">

                <!--                              <download-excel :data="items_filtered"-->
                <!--                                              name="Products.xls"-->
                <!--                                              :fields="json_fields"-->
                <!--                              >-->
                <!--                                  <CButton id="download_excel" color="secondary">-->
                <!--                                      {{ $t('buttons.print') }}-->

                <!--                                  </CButton>-->
                <!--                              </download-excel>-->
                <CButton class="mr-1" @click="got_to_add_product()" type="submit" size="sm" color="secondary">
                  {{ $t('buttons.addProduct') }}
                </CButton>
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header_title_height(body_id,header_id,footer_id,$t('sidebars.listProduct'),120,100)"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
                <CButton
                    v-if="get_access('hyper_sale')"
                    class="mr-1"
                    size="sm"
                    @click="print_element('printThermalBarcodes', '123')"
                    color="secondary"
                >پرینت بارکدی این صفحه
                </CButton>
                <CButton
                    v-if="get_access('hyper_sale')"
                    class="mr-1"
                    size="sm"
                    @click="print_element('printA4products', '123')"
                    color="secondary"
                >پرینت A4 کالا ها
                </CButton>
                <CButton
                    v-if="get_access('hyper_sale')"
                    class="mr-1"
                    size="sm"
                    @click="download_excel_tarazo()"
                    color="secondary"
                >خروجی اکسل ترازو
                </CButton>

              </CCol>
              <CCol col="3" v-if="get_access('small_store')">

                <CButton
                    class="mr-1"
                    size="sm"
                    @click="syncing_products_get()"
                    color="secondary"
                >بروزرسانی کالا با فروشگاه
                </CButton>
              </CCol>
            </CRow>


          </CCardHeader>
          <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
            <CCol>
              <CRow style="justify-content:center">
                <strong style="font-size: large">{{ get_bussiness_name() }}</strong>
              </CRow>

              <CRow style="justify-content:center">
                <strong>{{ $t('sidebars.listProduct') }}</strong>
              </CRow>
              <CRow>
                <!--                        <CCol >-->
                <!--                          <label>{{$t('FromDate')}} {{get_date(start_date)}}</label>-->
                <!--                          <br>-->
                <!--                          <label>{{$t('UpToDate')}} {{get_date(end_date)}}</label>-->
                <!--                        </CCol>-->
                <!--                        <CCol >-->
                <!--                          <label>{{$t('PreparedDate')}} {{get_date(get_today())}}</label>-->
                <!--                        </CCol>-->
              </CRow>

            </CCol>

          </div>
          <div v-show="false" :id="footer_id" class="border-dark">
            <CCardHeader>
              <CRow style="border: 1px solid #000">


                <CCol sm="4" md="4" style="text-align: start">
                  <h2>{{ $t('docCreator') }} : {{ get_user_name() }}</h2>
                </CCol>
                <CCol sm="4" md="4" style="text-align: center">
                  <h2 id="pageFooter" class="pageFooter"></h2>
                </CCol>
                <CCol sm="4" md="4" style="text-align: end">
                  <h2>
                  </h2>
                </CCol>
              </CRow>

            </CCardHeader>

          </div>

          <CCardBody :id="body_id">
            <CRow>
              <CCol col="3">
                <CSelect
                    :options="category_items"
                    :label="$t('components.productCategory')"
                    :value.sync="selected_category"
                    horizontal
                />
              </CCol>
              <CCol col="3">
                <CSelect
                    :options="brand_items"
                    :label="$t('components.productBrand')"
                    :value.sync="selected_brand"
                    horizontal
                />
              </CCol>
              <CCol col="3">
                <CSelect

                    :options="[{label:$t('all'),value:0},{label:$t('active'),value:39},{label:$t('deactivate'),value:40}]"
                    :label="$t('components.status')"
                    :value.sync="product_status"
                    horizontal
                />
              </CCol>
              <CCol col="1">
                <CButton @click="get_lists()" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('search')"
                    v-model="filter_table_txt"
                    horizontal
                />
              </CCol>
            </CRow>

            <CDataTableFixed
                :items="items_filtered"
                :fields="fields"
                @row-clicked="table_row_clicked"
                border
                :pagination="false"
                :height="get_pagination? '60vh' : ''"
                striped
                hover
                sorter
            >
              <!--                          :items-per-page="10"-->
              <!--                          :pagination="get_pagination"-->

              <template #row="{item,index}">

                <td>
                  <div style="text-align: center">{{ ((selected_page - 1) * 100) + index + 1 }}</div>

                </td>

              </template>

              <template #customerPrice="{item}">
                <td>
                  <div style="float:right" v-if="item.customerPrice!=null">{{ get_currency(item.customerPrice) }}</div>

                </td>

              </template>

              <template #productCode="{item}">
                <td>
                  <div style="text-align:center">{{ item.productCode }}</div>

                </td>

              </template>
              <template #lastPurchasePrice="{item}">

                <td>
                  <div style="float:right" v-if="item.lastPurchasePrice!=null">
                    {{ get_currency(item.lastPurchasePrice) }}
                  </div>

                </td>

              </template>
              <template #retailPrice="{item}">
                <td>
                  <div style="float:right" v-if="item.retailPrice!=null">
                    {{ get_currency(item.retailPrice * item.value) }}
                  </div>
                </td>
              </template>
              <template #salePrice="{item}">
                <td>
                  <div style="float:right" v-if="item.salePrice!=null">{{
                      get_currency(item.salePrice * item.value)
                    }}
                  </div>
                </td>
              </template>
              <template #commission="{item}">

                <td>
                  <div v-if="item.porsant!=null">{{ item.porsant }}</div>

                </td>

              </template>

              <template #unit="{item}">

                <td>
                  <div>{{ item.productUnitName }}</div>

                </td>

              </template>
              <template #brand="{item}">

                <td>
                  <div>{{ item.brandName }}</div>

                </td>

              </template>
              <template #catRelTitle="{item}">
                <td>
                  <div>{{ item.catRelTitle }}</div>
                </td>
              </template>
              <template #placeName="{item}">
                <td>
                  <div>{{ item.placeName }}</div>
                </td>
              </template>
              <template #barCode="{item}">

                <td>
                  <div>{{ item.barCode.substring(1) }}</div>

                </td>

              </template>
              <template #existence_value="{item}">

                <td>
                  <div style="float:right">{{ get_currency(item.existence_value, 2) }}</div>

                </td>

              </template>
              <template #image="{item}">


                <td>
                  <CImg width="45px" height="45px" v-bind:src="$root.base_url+'/'+item.imageName"/>
                </td>

              </template>

              <template #operation="{item,index}">
                <td>
                  <CButton
                      square
                      size="sm"
                      :title="$t('buttons.edit')"

                  >
                    <CIcon class="mr-1 text-primary" @click.native="goEditProduct(item,index)" size="sm"
                           name="cil-pencil"/>
                  </CButton>
                  <CButton
                      square
                      :title="$t('buttons.delete')"
                      size="sm"

                  >
                    <CIcon v-if="fields_data!='all'" @click.native="delete_item_dialog(item)" class="text-danger mr-1"
                           size="sm" name="cilTrash"/>
                  </CButton>

                </td>
              </template>


            </CDataTableFixed>
            <CPagination
                v-show="total_pages > 1"
                :activePage.sync="selected_page"
                :pages="total_pages"
            />
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <div id="printThermalBarcodes" style="background:white;display: none;">

      <div style="margin-top: 10px;width: 72mm;margin-right: 7mm">
        <div v-for="item in items_filtered.filter(x=>x.salePrice!=null && x.salePrice!=0)">
          <div style="border:2px solid black;color: black">
            <div class="text-center" style="font-size: 17px;font-weight: bold">
              {{ item.productName }}
            </div>
            <div v-if="parseFloat(item.takhfif)==0" class="text-center" style="font-weight:bold;font-size: 30px">
              {{ get_currency(item.salePrice) }}
              <div style="font-weight:bold;font-size:17px;margin-left: 10px">ریال</div>

            </div>

            <div style="display: flex;place-self: center;" v-if="parseFloat(item.takhfif)!=0">
              <div style="width:20%;text-align: left; margin-right: 5px;   justify-items: left;">
                <div
                    style="font-size: 20px;font-weight:bold;padding:10px;print-color-adjust:exact;background-color:black;color:white;width: fit-content">
                  {{ parseInt(item.takhfif) }}%
                </div>
              </div>

              <div style="margin-right: 5px;width:80%;text-align: center;">

                <div style="display:flex;place-self: center;">
                  <div class=" off-price " style="font-weight:bold;width:fit-content; font-size: 24px">

                    {{ get_currency(item.salePrice) }}

                  </div>

                </div>

                <div class="" style="display:flex;place-self: center;font-size: 30px;font-weight: bold">
                  <div  style="font-weight:bold;width:fit-content; font-size: 24px">
                    {{
                      get_currency(
                          parseFloat(item.salePrice) - ((parseFloat(item.salePrice) * parseFloat(item.takhfif)) / 100)
                      )
                    }}
                  </div>

                  <div style="margin-right: 5px;font-weight:bold;font-size:17px;margin-left: 10px">ریال</div>

                </div>

              </div>

            </div>

          </div>
          <div style="text-align: center;color: black;">
            {{ item.barCode }}
          </div>
          <div style="page-break-after: always"></div>

        </div>
      </div>

    </div>
    <div id="printA4products" style="background:white;display: none;">

      <div >
        <div v-for="item in items_filtered.filter(x=>x.salePrice!=null && x.salePrice!=0)" style="width:210mm;height:297mm;">
          <div style="border:5px solid black;height: 100%;width: 100%">
            <div class="text-center" style="margin-top: 100px;font-size: 80px;font-weight: bold">
              {{ item.productName }}
            </div>
            <div v-if="parseFloat(item.takhfif)==0" style="margin-top: 120px;font-weight:bold;text-align: center; font-size: 70px">
              {{ get_currency(item.salePrice/10) }}
              تومان
            </div>
            <div v-if="parseFloat(item.takhfif)!=0" style="margin-top: 80px;font-weight:bold;text-align: center; font-size: 70px">
              <div class="off-price">
                {{ get_currency(item.salePrice/10) }}
                تومان

              </div>
             <div>
               {{
                 get_currency(
                     (parseFloat(item.salePrice) - ((parseFloat(item.salePrice) * parseFloat(item.takhfif)) / 100))/10
                 )
               }}
             </div>

            </div>

            <div style="margin-top: 100px;display: flex;font-size: 70px;text-align: center;align-items: center;justify-content: center;" v-if="parseFloat(item.takhfif)!=0">
              <div
                  style="font-weight:bold;padding:10px;border:2px solid black;border-radius: 100%;width: 180px;height: 180px;align-content: center;">
                {{ parseInt(item.takhfif) }}%
              </div>
              <div style="margin-right: 20px">
                تخفیف
              </div>

            </div>

          </div>
          <div style="page-break-after: always"></div>

        </div>

      </div>

    </div>
    <download-excel
        type="xlsx"
        v-if="category_items.filter(x=>x.value==selected_category).length>0"
        :data="json_excel_tarazo"
        id="download_tarazo_excel"
        :name="category_items.filter(x=>x.value==selected_category)[0].label+'.xls'"
    >
      ترازو
    </download-excel>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];

import Vue from "vue";
import JsonExcel from "vue-excel-ultra";
import xlsx from "json-as-xlsx"

Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'ProductList',
  props: {
    fields_data: String
  },
  data() {
    return {
      product_status: 0,
      header_id: "print_report_header_products" + new Date().getTime() + this.$vnode.tag,
      footer_id: "print_report_footer_products" + new Date().getTime() + this.$vnode.tag,
      body_id: "print_report_body_products" + new Date().getTime() + this.$vnode.tag,
      confirm_delete_name: "delete_product_list" + new Date().getTime() + this.$vnode.tag,
      filter_table_txt: '',
      VUE_APP_Weight: localStorage.getItem('weight'),
      table_clicks: 0,
      table_clicks_timer: '',
      name: '',
      file: '',
      selected_page: 1,
      total_pages: 1,
      json_data: [],
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      json_excel_tarazo: [],
      search_text: '',
      category_items: [],
      selected_category: 0,
      brand_items: [],
      selected_brand: 0,
      items: [],
      items_filtered: [],
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:2%;text-align: center'},
        {key: 'productCode', label: this.$t('tables.code'), _style: 'width:5%'},
        {key: 'productName', label: this.$t('itemName'), _style: 'width:12%'},
        {key: 'customerPrice', label: this.$t('customerPrice'), _style: 'width:7%'},
        // {key: 'salePrice',label:this.$t('DeliveryPrice'), _style: 'width:6%'},
        // {key: 'retailPrice',label:this.$t('CollectionPrice'), _style: 'width:6%'},
        {key: 'existence_value', label: this.$t('components.existence'), _style: 'width:3%'},
        {key: 'barCode', label: this.$t('tables.barcode'), _style: 'width:5%'},
        {key: 'catRelTitle', label: this.$t('tables.category'), _style: 'width:10%'},
        // {key: 'placeName',label:this.$t('inventory'), _style: 'width:3%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},

      ],
      fields_sale_report: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:2%;text-align: center'},
        {key: 'productCode', label: this.$t('tables.code'), _style: 'width:5%'},
        {key: 'productName', label: this.$t('itemName'), _style: 'width:12%'},
        {key: 'catRelTitle', label: this.$t('tables.category'), _style: 'width:10%'},

        {key: 'customerPrice', label: this.$t('customerPrice1'), _style: 'width:7%'},

        {key: 'salePrice', label: this.$t('ProductDeliveryPrice'), _style: 'width:6%'},
        {key: 'retailPrice', label: this.$t('ProductInventoryPrice'), _style: 'width:6%'},
        {key: 'existence_value', label: this.$t('components.existence'), _style: 'width:3%'},
        // {key: 'barCode',label:this.$t('tables.barcode'), _style: 'width:5%'},
        {key: 'placeName', label: this.$t('inventory'), _style: 'width:3%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},

      ],

      fields_purchase_report: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:2%;text-align: center'},
        {key: 'productCode', label: this.$t('tables.code'), _style: 'width:5%'},
        {key: 'productName', label: this.$t('itemName'), _style: 'width:12%'},
        {key: 'lastPurchasePrice', label: this.$t('buyPrice'), _style: 'width:7%'},
        // {key: 'salePrice',label:this.$t('DeliveryPrice'), _style: 'width:6%'},
        // {key: 'retailPrice',label:this.$t('CollectionPrice'), _style: 'width:6%'},
        {key: 'existence_value', label: this.$t('components.existence'), _style: 'width:3%'},
        {key: 'barCode', label: this.$t('tables.barcode'), _style: 'width:5%'},
        {key: 'catRelTitle', label: this.$t('tables.category'), _style: 'width:10%'},
        // {key: 'placeName',label:this.$t('inventory'), _style: 'width:3%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},

      ],
      json_fields: {
        "Name": "productName",
        "Category": "catRelTitle",
        "Brand": "brandName",
        "Price": "customerPrice",
        "Sell Price": "salePrice",
        "Unit": "productUnitName",

      },
      details: [],
      search_handler: null,
      collapseDuration: 0,
      status_form: 0
    }
  },
  mounted() {
    if (this.fields_data == "purchase") {
      this.fields = this.fields_purchase_report;

    }
    if (this.fields_data == "sale") {
      this.fields = this.fields_sale_report;
    }

    this.$root.root_validate_errors = [];

    this.get_lists();
    this.get_categories();
    this.get_brands();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    'filter_table_txt': function () {
      if (this.search_handler != null) {
        clearTimeout(this.search_handler)
      }
      var self = this
      this.search_handler = setTimeout(function () {
        if (self.filter_table_txt.length > 2) {
          self.selected_page = 1
          self.total_pages = 1
          self.get_lists()
        }
        if (self.filter_table_txt.length == 0) {
          self.selected_page = 1
          self.total_pages = 1
          self.get_lists()
        }
      }, 700)
    },
    'selected_page': function () {
      this.get_lists()
    },
    '$route.params.cat_id': function () {
      this.selected_page = 1
      this.total_pages = 1
      this.get_lists()
    },
    'selected_category': function () {
      this.selected_page = 1
      this.total_pages = 1
      this.get_lists()
    },
    'selected_brand': function () {
      this.selected_page = 1
      this.total_pages = 1
      this.get_lists()
    },
    'product_status': function () {
      this.selected_page = 1
      this.total_pages = 1
      this.get_lists()
    }
  },
  methods: {
    filter_data() {
      this.items_filtered = this.items;

      if (this.selected_category == 0 && this.selected_brand == 0) {
        this.items_filtered = this.items;
        return false;
      }
      if (this.selected_category != 0) {
        this.items_filtered = this.items_filtered.filter(x => x.catRelId == this.selected_category);
      }
      if (this.selected_brand != 0) {
        this.items_filtered = this.items_filtered.filter(x => x.brandId == this.selected_brand);
      }
    },
    table_row_clicked(item, index, column) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0

        this.goEditProduct(item)
      }
    },
    get_categories() {
      var self = this;
      this.$apis.get_cats().then(result => {
        self.category_items = result
      })

    },
    get_brands() {
      const self = this
      this.$apis.get_brands(self.$t('all')).then(result => {
        self.brand_items = result

      })

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    got_to_add_product() {
      this.$router.push({path: '/dashboard/products/create'})

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetProducts";
      if (self.$route.params.cat_id != null) {
        url = "GetProductsByCatId";
        formData.append('id', self.$route.params.cat_id);

      }
      if (self.$route.params.brand_id != null) {
        url = "GetProducts";
        formData.append('BrandId', self.$route.params.brand_id);

      }


      formData.append('PageNo', this.selected_page);
      formData.append('Rows', 100);
      formData.append('StatusId', self.product_status);
      if (self.selected_category != 0) {
        formData.append('CatRelId', self.selected_category);
      }
      if (self.selected_brand != 0) {
        formData.append('BrandId', self.selected_brand);
      }
      if (self.filter_table_txt.length > 2) {
        formData.append('SearchTxt', self.filter_table_txt);
      }

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          if (content_data.data.length > 0) {
            self.total_pages = parseInt(content_data.data[0].totalRow / 100);
            if (content_data.data[0].totalRow % 100 > 0) {
              self.total_pages++
            }
          } else {
            self.total_pages = 1;
          }
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items.forEach(function (val) {
            // val.existence_value = val.existence / val.value
            val.existence_value = val.packStock
          })
          self.items_filtered = self.items;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    download_excel_tarazo() {
      var self = this;


      const formData = new FormData();

      var url = "GetProducts";

      formData.append('PageNo', 1);
      formData.append('Rows', 300);
      formData.append('StatusId', self.product_status);
      if (self.selected_category != 0) {
        formData.append('CatRelId', self.selected_category);
      }
      if (self.selected_brand != 0) {
        formData.append('BrandId', self.selected_brand);
      }
      if (self.filter_table_txt.length > 2) {
        formData.append('SearchTxt', self.filter_table_txt);
      }

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          content_data.data = content_data.data.reverse()
          var pros = []
          // try {
          content_data.data.forEach(function (val, index) {
            // if(val.salePrice==null){
            // self.$root.root_validate_errors.push("یک یا چند کالا قیمت فروش ندارند");
            // throw BreakException;
            // }
            pros.push({
              plu_index: index + 1,
              prod_id: val.barCode,
              name: val.productName,
              barcode: val.barCode,
              price: val.salePrice==0? 1 : parseInt(val.salePrice - ((val.salePrice*val.takhfif)/100)).toString(),
              purchase_price: "0",
              tax: "0",
              stock: "0",
              point_order: "0",
              change_price: "TRUE",
              unit: "A",
            })
          })
          const fileName = self.category_items.filter(x => x.value == self.selected_category)[0].label
          let settings = {
            fileName: fileName, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
            RTL: false, // Display the columns from right-to-left (the default value is false)
          }
          let data_json = [
            {
              sheet: "Sheet1",
              columns: [
                {label: "plu_index", value: "plu_index"}, // Top level data
                {label: "prod_id", value: "prod_id"}, // Top level data
                {label: "name", value: "name"}, // Top level data
                {label: "barcode", value: "barcode"}, // Top level data
                {label: "price", value: "price"}, // Top level data
                {label: "purchase_price", value: "purchase_price"}, // Top level data
                {label: "tax", value: "tax"}, // Top level data
                {label: "stock", value: "stock"}, // Top level data
                {label: "point_order", value: "point_order"}, // Top level data
                {label: "change_price", value: "change_price"}, // Top level data
                {label: "unit", value: "unit"}, // Top level data
              ],
              content: pros,
            },
          ]

          xlsx(data_json, settings)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    syncing_products_get() {
      var self = this;


      const formData = new FormData();

      var url = "GetProducts";

      formData.append('PageNo', 1);
      formData.append('Rows', 1000);
      formData.append('StatusId', 0);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          content_data.data = content_data.data.reverse()
          self.syncing_products_send(content_data.data)
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    syncing_products_send(products) {
      var self = this;


      const formData = new FormData();

      var url = this.get_access('small_store_api') + "/PartyProductImport";
      // formData.append("items", JSON.stringify(products));

      // "small_store_api": "https://dbtest.chasbo.ir",
      //     "small_store_key": "9bea2a27-4db7-f011-916e-b006952ebad5",
      axios.post(url, products, {
        headers: {
          'secret': this.get_access('small_store_key')
        }
      }).then(function (response) {

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    goEditProduct(item, index) {

      window.open('/dashboard/products/edit/' + item.id)

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DelProductBarCode";


      formData.append('ProductId', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_products_print() {
      var self = this;

      var url = "GetProductsFullInfo";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      // formData.append("id", 1);

      axios.get(url, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              self.export_file_name = "Products.xls"


              self.json_data = response.data.data.map((item, row) => {
                return {...item, row}
              });
              setTimeout(() =>
                      document.getElementById('download_excel').click()

                  , 1500);
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
